import { FilterXIcon, SaveIcon } from 'lucide-react';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardPresets } from '@/entities/settings';
import { IconButton } from '@/shared/ui';

/**
 * Действия над несохранёнными изменениями автора системного дашборда — фильтрами и видом колонок,
 * которые пока действуют только у него. Стоят слева от кнопки списка дашбордов, как отмена и
 * сохранение изменённого пресета в строке поиска списка диалогов: «Отменить изменения» снимает их
 * все, «Сохранить изменения» записывает в дашборд для всех. Изменений нет — ничего не показано.
 */
export const DashboardUnsavedChanges: FC = () => {
  const { t } = useTranslation('qualityDashboard');
  const { activePreset, saveUnsavedChanges, discardUnsavedChanges } = useDashboardPresets();
  // Пока запись идёт, повторное нажатие записало бы те же изменения второй раз
  const [isSaving, setIsSaving] = useState(false);

  if (!activePreset?.hasUnsavedChanges) return null;

  const handleSave = async () => {
    setIsSaving(true);
    await saveUnsavedChanges();
    setIsSaving(false);
  };

  return (
    <div className="flex items-center gap-1">
      <IconButton
        variant="ghost"
        size="icon"
        label={t('presets.discardChanges')}
        icon={<FilterXIcon className="size-4" />}
        disabled={isSaving}
        onClick={discardUnsavedChanges}
      />
      <IconButton
        variant="ghost"
        size="icon"
        label={t('presets.saveChanges')}
        icon={<SaveIcon className="size-4" />}
        disabled={isSaving}
        onClick={handleSave}
      />
    </div>
  );
};
